import logger from '../utils/rbata.logger';
import urlUtils from './rbata.urlService';

let personalizedProductData = undefined;

const personalizedProductService = {
    clearPersonalizedProductData() {
        personalizedProductData = undefined;
    },
    setPersonalizedProductData(data) {
        personalizedProductData = data;
    },
    fetchPersonalizedProductDataRequest(variantCode) {
        const url = `${urlUtils.getBaseUrl()}p/${variantCode}/personalize`;
        return $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });
    },
    fetchPersonalizedProductData(variantCode) {
        if (!personalizedProductData) {
            logger.log('fetch personalized product data from server');
            let deferred = $.Deferred();

            this.fetchPersonalizedProductDataRequest(variantCode).then((data) => {
                personalizedProductData = data;
                deferred.resolve(personalizedProductData);
            }, (jqXHR) => {
                logger.error(`${jqXHR.status} error in personalizedProductService`);
                deferred.reject(jqXHR);
            });
            personalizedProductData = deferred.promise();
        }
        return $.when(personalizedProductData);
    },
    fetchRestrictedVariantInfo(variantCode) {
        const url = `${urlUtils.getBaseUrl()}p/${variantCode}/restrictedVariant/`;
        return $.ajax({
            url:    url,
            method: 'GET',
            cache:  true
        });
    }
};

export default personalizedProductService;
